const toggleLikedItems = (isReload) => {
  const formDataLiked = new FormData();
  formDataLiked.append('action', 'shopGetLikedItems');
  axios
    .post(localData.apiURL, formDataLiked, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      if (response.status === 200) {
        const likedWishList = document.querySelector('.sc-wish-list');
        if (likedWishList) {
          // eslint-disable-next-line no-param-reassign
          likedWishList.querySelector('.liked-items-list').innerHTML = response.data.html;
        }
        const singleProduct = document.querySelector('.single-product');
        if (singleProduct && isReload) {
          singleProduct.querySelector('.add-wish-item').hidden = response.data.ids.includes(localData.id);
          singleProduct.querySelector('.remove-wish-item').hidden = !response.data.ids.includes(localData.id);
          singleProduct
            .querySelector('.wishlist-button')
            .classList.toggle('is-active', response.data.ids.includes(localData.id));
        }
        axiosProfileData();
      }
    })
    .catch((err) => {
      console.error(err);
    });
};
attachEvent('.product-card__remove-button, .wishlist-button', 'click', (e) => {
  e.preventDefault();
  if (e.target.classList.contains('wishlist-button')) {
    e.target.querySelector('.add-wish-item').hidden = e.target.classList.contains('is-active');
    e.target.querySelector('.remove-wish-item').hidden = !e.target.classList.contains('is-active');
  }
  const card = e.target.closest('.add-cart, .product-card');
  const productId = card.dataset.product_id;
  if (productId) {
    const axiosData = new FormData();
    axiosData.append('action', 'toggleItemOnLikedList');
    axiosData.append('product_id', productId);
    axios
      .post(localData.apiURL, axiosData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        if (response.status === 200) {
          toggleLikedItems(false);
          axiosProfileData();
        }
      });
  }
});
const wishList = document.querySelector('.sc-wish-list, .single-product .add-cart');
if (wishList) {
  toggleLikedItems(true);
}
